<div class="row col-12 p-0 m-0 main-page-section ">
    <!-- <div class="p-0">
              <app-side-nav [item]="meetingNav"></app-side-nav>
          </div> -->
    <div class="col-12 p-0 bulk-upload-preview">
        <!-- <app-header></app-header> -->
        <div class="col-height">
            <div>
                <div class="breadcrumbs-section padding-left">
                    <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="separator">&nbsp; &nbsp;</span>
                    <span class="prev-page pr-2 prev"><a routerLink="/create-coupon">Create New Coupon</a></span>
                    <img src="../../assets/images/seperator.png">
                    <span class="prev-page pr-2 pl-2 prev"><a routerLink="/bulk-upload-coupon">Bulk Upload</a></span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pl-2 breadcrumbs-section-font current">Preview</span>
                </div>

                <div class="invite-layout">

                    <div class="row">
                        <div class="col-9">
                            <h1>Bulk Upload</h1>
                        </div>
                        <div class="col-3 upload-btn-wrapper">
                            <button type="submit">Re-upload Excel Sheet here</button>
                            <input type="file"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                name="myfile" (change)="bulkInvite($event)" />
                        </div>
                    </div>

                    <div class="row mt-4" *ngIf="tableHeaders.length > 0">
                        <div class="col-12 guest-count">{{tableBody.length}} Coupons</div>
                    </div>

                    <div class="row">
                        <div class="col-12 scroll">
                            <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable"
                                #pdfTable *ngIf="tableHeaders.length > 0">
                                <thead>
                                    <tr>
                                        <!-- <th class="check-container">
                                            <label class="check-container">
                                                <input type="checkbox" [checked]="selectAll" [value]="selectAll"
                                                    [(ngModel)]="selectAll" (change)="selectAllHandler()">
                                                <span class="checkmark"></span>
                                            </label>
                                        </th> -->
                                        <th *ngFor="let th of tableHeaders | slice:0:9;" scope="col">{{th}}</th>
                                        <!-- <th></th>
                                        <th>
                                            <i class="fa fa-2x fa-trash" aria-hidden="true" (click)="deleteAllInvites()"
                                                [ngClass]="{'disabledClick':!selectAll}"></i>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let td of tableBody; let i = index" [id]="generateUniqueId(i,'tr')"
                                        [ngClass]="{'error-row': validationError[i]?.length > 0 ||  isValid[i] == false }">
                                        <!-- <td class="check-container">
                                            <label class="check-container">
                                                <input type="checkbox" [checked]="selectAll" [value]="selectAll"
                                                    (change)="selectedGuest(td, i, $event)"
                                                    [id]="generateUniqueId(i,'th')" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </td> -->

                                        <td *ngFor="let cell of td | slice:0:9 |  keyvalue;let j = index ">
                                            <span [ngClass]="generateUniqueId(i,'td')"
                                                style="display: block;">{{cell.value}}</span>
                                            <input *ngIf="j!='2' && j!='3'" type="text"
                                                [ngClass]="generateUniqueId(i,'input')" style="display: none;"
                                                [value]="cell.value" class="edit-input" />
                                            <input *ngIf="j=='2'" type="text" [ngClass]="generateUniqueId(i,'input')"
                                                style="display: none;" [value]="cell.value" class="edit-input"
                                                autocomplete="off" (click)="d1.toggle()"
                                                (keypress)="$event.preventDefault()"
                                                (dateSelect)="updateSelectedDate($event)" ngbDatepicker
                                                #d1="ngbDatepicker" [(ngModel)]="couponsection.bulkStartDate"
                                                [ngModelOptions]="{standalone: true}" />
                                            <input *ngIf="j=='3'" type="text" [ngClass]="generateUniqueId(i,'input')"
                                                style="display: none;" [value]="cell.value" class="edit-input"
                                                autocomplete="off" (click)="d1.toggle()"
                                                (keypress)="$event.preventDefault()"
                                                (dateSelect)="updateSelectedToDate($event)" ngbDatepicker
                                                #d1="ngbDatepicker" [(ngModel)]="couponsection.bulkEndDate"
                                                [ngModelOptions]="{standalone: true}" />
                                            <span *ngIf="j != 0 && validationError[i] != null  "
                                                class="error-row-display">{{validationError[i][j-1] }}</span>
                                            <!-- <span *ngIf="j == 1 && isValid[i] == false " class="error-row-display">user already exists.</span> -->
                                        </td>
                                        <!-- <td>
                                            <i class="fa fa-2x fa-pencil" aria-hidden="true"
                                                [ngClass]="checkIfSelected(i+'__th')"
                                                (click)="editSelected(i+'__td', i+'__input', i, 'edit')"
                                                [id]="generateUniqueId(i,'edit')" style="display: block;"></i>
                                            <span [id]="generateUniqueId(i,'save')"
                                                style="display: none; cursor: pointer;"
                                                (click)="editSelected(i+'__td', i+'__input', i, 'save')"
                                                class="save-btn">Save</span>
                                            <span [id]="generateUniqueId(i,'cancel')" style="display: none;"
                                                (click)="editSelected(i+'__td', i+'__input', i, 'cancel')"
                                                class="save-btn">Cancel</span>
                                        </td>
                                        <td>
                                            <i class="fa fa-2x fa-trash" aria-hidden="true"
                                                [ngClass]="checkIfSelected(i+'__th')"
                                                (click)="deleteSelected(td,i)"></i>
                                        </td> -->
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>


            <div class="row footer-layout " *ngIf="tableHeaders.length > 0">
                <div class="col-2 align-right">
                    <button class="button-cancel" routerLink="/bulk-upload-coupon">Cancel</button>
                </div>
                <div class="col-2">
                    <button class="button-resend" [disabled]="validationEr" (click)="send()">Bulk Upload</button>
                </div>
            </div>


            <!-- <app-footer></app-footer> -->

        </div>
    </div>